<template>
  <div class="headerBox">
    <div
      class="whiteCircle"
      :class="[
        isOrder ? 'whiteCircle-isOrder' : '',
        hasOrderCircleBackground ? 'whiteCircle-hasOrderCircleBackground' : '',
        isPayment ? 'whiteCircle-isPayment' : '',
        isPaymentStart ? 'whiteCircle-isPaymentStart' : '',
        isPaymentSuccess ? 'whiteCircle-isPaymentSuccess' : ''
      ]"
    ></div>
  </div>
</template>
<script>
import { isBackgroundImageSet } from "@/utils/helpers";

export default {
  data() {
    return {
      isPaymentSuccess: false
    };
  },
  props: {
    isOrder: Boolean,
    isPayment: Boolean,
    isPaymentStart: Boolean
  },
  computed: {
    hasOrderCircleBackground() {
      return isBackgroundImageSet(
        "--component_OrderHeader_whiteCircle-isOrder_background-image"
      );
    }
  },
  methods: {
    paymentIsDone() {
      this.isPaymentSuccess = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.whiteCircle {
  position: absolute;
  top: -605px;
  left: -64px;
  width: 1196px;
  height: 1196px;
  border-radius: 50%;
  background: transparent
    linear-gradient(12deg, #fcf7f4 0%, #ffffff 61%, #ffffff 100%) 0% 0%
    no-repeat padding-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.whiteCircle-isOrder {
  top: var(--component_OrderHeader_whiteCircle-isOrder_top);
  left: var(--component_OrderHeader_whiteCircle-isOrder_left);
  width: var(--component_OrderHeader_whiteCircle-isOrder_width);
  height: var(--component_OrderHeader_whiteCircle-isOrder_height);
  background: var(--component_OrderHeader_whiteCircle-isOrder_background);
  background-size: var(
    --component_OrderHeader_whiteCircle-isOrder_background-size
  );
}
.whiteCircle-hasOrderCircleBackground {
  background-image: var(
    --component_OrderHeader_whiteCircle-isOrder_background-image
  );
}
.whiteCircle-isPayment {
  background: var(--component_OrderHeader_whiteCircle-isPayment_background);
}
.whiteCircle-isPaymentSuccess {
  background: var(
    --component_OrderHeader_whiteCircle-isPaymentSuccess_background
  );
}
.whiteCircle-isPaymentStart {
  background: var(
    --component_OrderHeader_whiteCircle-isPaymentStart_background
  );
}
</style>
